import { render, staticRenderFns } from "./TypeCard.vue?vue&type=template&id=b341028a&scoped=true"
import script from "./TypeCard.vue?vue&type=script&lang=js"
export * from "./TypeCard.vue?vue&type=script&lang=js"
import style0 from "./TypeCard.vue?vue&type=style&index=0&id=b341028a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b341028a",
  null
  
)

export default component.exports